@if (form) {
  <div [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
      label: seFeDataLabel,
      hiddenLabel,
      errorMessages: {
        inviteExists: 'SE_PO_UI_EMAIL.ERRORS.inviteExists' | translate,
        maxlength: 'SE_PO_UI_EMAIL.ERRORS.email' | translate,
        invalidEmail: 'SE_PO_UI_EMAIL.ERRORS.email' | translate,
        required: 'SE_PO_UI_EMAIL.ERRORS.required' | translate
      }
    }">
      <se-fe-form-field-text
        [formControlName]="ngControl.name"
        seFeDataInputMode="email"
        seFeDataAutoComplete="email"
        [seFeDataComfy]="true">
        <se-fe-icon class="email-icon" seFeFormFieldTextBefore
          seFeDataName="envelope"
          seFeDataSize="600">
        </se-fe-icon>
      </se-fe-form-field-text>
    </se-fe-form-field>
  }
</div>
}
